// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3tuId","header":"ReportDetails_header__3tx8O","title":"ReportDetails_title__1OTGW","left":"ReportDetails_left__38Jye"};